/* Shared cases store — single source of truth for /api/cases data.
 * Built on the generic createListStore factory.
 *
 * Before this store existed, both `CaseDashboard.jsx` (desktop) and
 * `MobileCases.jsx` (mobile) each fetched `/api/cases` on every mount,
 * doubling backend load and adding 100-200 ms of client latency. The
 * shared cache + inflight dedupe fixes that.
 */
import { listCases } from "./api";
import { createListStore } from "./createListStore";

const store = createListStore({
  fetcher: listCases,
  staleMs: 30_000,
  name: "cases",
});

export const fetchCases = store.fetch;
export const prefetchCases = store.prefetch;
export const invalidateCases = store.invalidate;

// Adapter — keeps the pre-existing `useCases()` shape { cases, loading,
// error, refresh } that consumers rely on. Renaming `data` → `cases`.
export function useCases() {
  const { data, loading, error, refresh } = store.useData();
  return {
    cases: data || [],
    loading,
    error,
    refresh,
  };
}
